export var CharactersEnum;
(function (CharactersEnum) {
    CharactersEnum["AT"] = "@";
    CharactersEnum["ASTERISK"] = "*";
    CharactersEnum["COMMA_SPACE"] = ", ";
    CharactersEnum["COMMA_LINE_BREAK"] = ", \n";
    CharactersEnum["HASH"] = "#";
    CharactersEnum["MAIL_TO"] = "mailto:";
    CharactersEnum["PARENTHESIS_CLOSE"] = ")";
    CharactersEnum["PARENTHESIS_OPEN"] = "(";
    CharactersEnum["NO_VALUE"] = "-";
    CharactersEnum["SLASH"] = "/";
})(CharactersEnum || (CharactersEnum = {}));
//# sourceMappingURL=characters.enum.js.map